<template>
  <div>
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <Dialog header="Reverse Transaction" :visible.sync="showReverseDialog"
     :style="{width: '50vw', height:'70vw'}" style="overflow-y: auto;" :modal="true"  :contentStyle="{'overflow': 'visible'}" @show="modalshows">
     <div class="container">
     <div class="col-md-2">
       <label>Date</label>
       <date-picker  ref="tran" v-model="transactionDate"  valueType="format" v-if="!englishDateEnabled"/>
       <InputMask placeholder="Please select Date"  mask="9999-99-99" type="text" v-else class="nepali-calendar form-control"  id="transactionDate" v-model="transactionDate"/>
     </div>
   </div>
     <div><h4>Actual Transaction</h4></div>
     <table class="table table-bordered">
       <thead>
         <tr>
           <th>S.N</th>
           <th>Account</th>
           <th>Debit</th>
           <th>Credit</th>
           <th >Cheque Date</th>
           <th >Cheque Number</th>
           <th>Short Narration</th>
        </tr>
       </thead>
       <tbody v-for="(account,index) in actualTransactionsList " :key="index">
         <tr>
           <td>{{index+1}}</td>
           <td>{{account.accountMaster.name}}</td>
           <td style="text-align:right;color:#00a65a;">{{account.drCr == 'D'?account.txnAmount:''}}</td>
           <td style="text-align:right;color:#dd4b39;">{{account.drCr == 'C'?account.txnAmount:''}} </td>
           <td >{{account.chequeDate}} </td>
           <td >{{account.chequeNumber}} </td>
           <td >{{account.narration3}} </td>
         </tr>
       </tbody>
     </table>
     <div><h4>Reverse Transaction</h4></div>
     <table class="table table-bordered">
       <thead>
         <tr>
           <th>S.N</th>
           <th>Account</th>
           <th>Debit</th>
           <th>Credit</th>
           <th scope="col" >Cheque Date</th>
           <th scope="col">Cheque Number</th>
           <th>Short Narration</th>
        </tr>
       </thead>
       <tbody v-for="(account,index) in reversalTransactionList " :key="index">
         <tr>
           <td>{{index+1}}</td>
           <td>{{account.accountMaster.name}}</td>
           <td style="text-align:right;color:#00a65a;">{{account.drCr == 'D'?account.txnAmount:''}}</td>
           <td style="text-align:right;color:#dd4b39;">{{account.drCr == 'C'?account.txnAmount:''}} </td>
           <td >{{account.chequeDate}} </td>
           <td >{{account.chequeNumber}} </td>
           <td >{{account.narration3}} </td>
         </tr>
       </tbody>
     </table>
     <div class="container-fluid">
     <div class="col-md-3">
       <label  class="control-label" >Narration</label>
       <textarea
         type="text"
         class="form-control"
         style="width:300px;"
         id="narration1"
         cols="10"
         rows="3"
         v-model="narration"
       />
     </div>

   </div>
   <template #footer>
     <Button  class="p-button-raised p-button-rounded"
      @click.prevent="reverseTransaction" label="Reverse"/>
     <Button  @click.prevent="cancel" class="p-button-raised p-button-danger" label="Cancel"/>
   </template>
   </Dialog>
  </div>

</template>
<script>
import Dialog from 'primevue/dialog'
import InputMask from 'primevue/inputmask'
import $ from 'jquery'
import DatePicker from 'vue2-datepicker'
import Button from 'primevue/button'
export default {
  name: 'reverseDialog',
  data() {
    return {
      showReverseDialog: false,
      loading: false,
      bank: false,
      cheque: false,
      englishDateEnabled: true,
      transactionDate: null,
      drCr: '',
      chequeNumber: '',
      narration: '',
      actualTransactionsList: [],
      reversalTransactionList: [],
      transactionDetailDTOList: [],
      reversalTransactionDetailDTOList: []
    }
  },
  mounted () {
  },
  methods: {
    async openReverseDialog(data) {
      let journalLeg = {
        tranId: data.tranId,
        tranModuleType: data.tranModuleType
      }
      let response = await this.$store.dispatch('loadaccountLedger', journalLeg)
      this.actualTransactionsList = response.data.data.transactionDetailDTOList
      this.actualTransactionsList.forEach(actTrans => {
        if (actTrans.drCr === 'D') {
          this.drCr = 'C'
        } else {
          this.drCr = 'D'
        }
        let transaction = {
          accountMaster: actTrans.accountMaster,
          narration3: actTrans.narration3,
          txnAmount: actTrans.txnAmount,
          chequeDate: actTrans.chequeDate,
          chequeNumber: actTrans.chequeNumber,
          drCr: this.drCr
        }
        this.reversalTransactionList.push({...transaction})
      })
      this.transactionDetailDTOList = this.reversalTransactionList
      this.reversalTransactionDetailDTOList = this.actualTransactionsList
      this.showReverseDialog = true
      // this.checkForChequeDate()
    },
    async reverseTransaction() {
      if (this.transactionDate === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select  Transaction date!', life: 10000})
        return
      }
      if (this.narration === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Narration Cannot be empty!', life: 10000})
        return
      }
      let reverseTransactionData = {
        transactionDate: this.transactionDate,
        narration1: this.narration,
        chequeNumber: this.chequeNumber,
        chequeDate: this.chequeDate,
        fiscalYear: this.$store.getters.fyId,
        transactionDetailDTOList: this.transactionDetailDTOList,
        reversalTransactionDetailDTOList: this.reversalTransactionDetailDTOList
      }
      // // debugger
      let response = await this.$store.dispatch('reverseJournalTransaction', reverseTransactionData)
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        this.cancel()
      }
    },
    cancel() {
      this.showReverseDialog = false
      this.narration = ''
      this.actualTransactionsList = []
      this.reversalTransactionList = []
      this.transactionDetailDTOList = []
      this.reversalTransactionDetailDTOList = []
    },
    modalshows() {
      this.checkEnglish()
      if (!this.$store.state.isEnglishDateEnabled || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
      }
      if (!this.$store.state.isEnglishDateEnabled && this.creditNote === undefined ||
        this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      }
      if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
        this.setEnglishDate()
      }
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    setEnglishDate() {
      this.transactionDate = new Date().toISOString().slice(0, 10)
    },
    setNepaliDate() {
      if (this.reverseDialog === undefined) {
        this.transactionDate = this.$store.getters.nepaliNewDate
      }
    },
    nepaliDate() {
      $('#transactionDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.transactionDate = $('#transactionDate').val()
        }
      })
    }
    // checkForChequeDate() {
    //   // debugger
    //   if (this.account.isBankAccount || this.account.isBankAccount === undefined) {
    //     if (this.account.isBankAccount) {
    //       this.bank = true
    //     } else if (this.account.isBankAccount === undefined) {
    //       this.bank = false
    //     } else if (!this.account.isBankAccount) {
    //       this.bank = false
    //     }
    //     if (this.chequeNumber !== '') {
    //       this.cheque = true
    //     } else if (this.chequeNumber === '') {
    //       this.cheque = false
    //     }
    //   }
    // }
  },
  components: {
    Dialog,
    InputMask,
    DatePicker,
    Button
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// reverseDialog.vue?52fb3afa